import PDFAnnotator from './PDFAnnotator.view';

export default PDFAnnotator;
